import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    // min width override as MUI default min-width is wider than 'pickup' text
    minWidth: 0,
    [theme.breakpoints.up('md')]: {
      padding: '10px 0 7px 0',
      textTransform: 'none',
      borderRadius: 0,
      borderBottom: ({ highlighted }) =>
        `2px ${
          highlighted ? theme.palette.secondary.main : 'transparent'
        } solid`
    }
  }
}));

const NavLink = ({ highlighted, fullWidth, dataTestId, children }) => {
  const classes = useStyles({ highlighted });
  return (
    <Button
      fullWidth={fullWidth}
      classes={classes}
      variant="text"
      data-testid={dataTestId}
    >
      {children}
    </Button>
  );
};

NavLink.defaultProps = {
  fullWidth: false
};
NavLink.propTypes = {
  highlighted: PropTypes.bool,
  fullWidth: PropTypes.bool,
  classes: PropTypes.shape({}),
  dataTestId: PropTypes.string,
  children: PropTypes.node
};

export default NavLink;
